<button mat-stroked-button (click)="onClick()" [disabled]="disabled">
    {{ title }}
</button>
